import {Injectable} from '@angular/core';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import {HttpManagerService}  from '../../api/httpmanager.service';


@Injectable()
export class BlogService {
    constructor(private httpmanagerService: HttpManagerService) {
    }

    allBlog(id): Promise<any> {
        return this.httpmanagerService.HttpGet('blog', id).then(function (data) {
           
            return data;
        });
    }

    allHiring(): Promise<any> {
        return this.httpmanagerService.HttpGet('hiring', "").then(function (data) {
            return data.data;
        });
    }

    iHiring(app): Promise<any> {
        return this.httpmanagerService.HttpPost('hiring', JSON.stringify(app), "").then(function (data) {
            return data;
        });
    }

    iBlog(app,image,is_form_data): Promise<any> {
        return this.httpmanagerService.HttpPostBlogImage('blog', JSON.stringify(app),image,is_form_data, "").then(function (data) {
            return data;
        });
    }
    uBlog(id, data,image,is_form_data): Promise<any> {
        return this.httpmanagerService.HttpPutBlogImage('blog', JSON.stringify(data),image,is_form_data, id).then(function (data) {
            return data;
        });
    }
    uHiringindex(app): Promise<any> {
        return this.httpmanagerService.HttpPost('hiring/updateindex', JSON.stringify(app), "").then(function (data) {
            return data;
        });
    }

    dHiring(id): Promise<any> {
        return this.httpmanagerService.HttpDelete('hiring', id).then(data => {
            return data;
        })
    }
}


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix Website/Website_Admin/src/api/blog/blog.service.ts